import { weightLossCv } from './initial/flow';

const WeightLossCVFlows = {
  weightLossCv
};

export default WeightLossCVFlows;
